import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { MDash } from 'ui-components/components/mdash';

import messages from '../messages';
import style from './style.module.less';

const name = (
  <Tooltip position='bottom'>
    <TooltipContent>
      <div className={style['tooltip-text']}>
        <p>
          <FormattedMessage {...messages.committedTooltipMessage} />
        </p>
      </div>
    </TooltipContent>
    <div className={style.header}>
      <FormattedMessage {...messages.committedColumnHeader} />
      <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />
    </div>
  </Tooltip>
);

const CommittedColumn = ({ aggregateInventoryCounts, isBundle }) => {
  return <div className={style['right-align-column']}>{isBundle ? <MDash /> : (aggregateInventoryCounts?.committedQuantity ?? 0)}</div>;
};

export default {
  getMessageDescriptor: () => messages.committedColumnHeader,
  name,
  render: CommittedColumn,
};
